import React, { useEffect, useState } from 'react';
import LeaderBoardList from '../../../component/EliteGame/LeaderBoardList';
import { getMonthlyLeaderBoard } from '../../../api/eliteGameApi';

const MonthlyLeaderBoard = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    fetchData(page);
  }, [page]);

  const fetchData = async (pageNum) => {
    const response = await getMonthlyLeaderBoard({ page: pageNum, limit: 10 });
    setData(response);
  };

  const handlePagination = (newPage) => {
    setPage(newPage);
  };

  return (
    <LeaderBoardList
      data={data}
      page={page}
      header="Monthly LeaderBoard"
      handlePagination={handlePagination}
    />
  );
};

export default MonthlyLeaderBoard;
